import { IPlayerConfig } from '../types';

export default abstract class SignalController {
  protected env: string = 'prod';
  protected fetchTimeout: number = 2000;
  protected timerId: NodeJS.Timeout;
  protected abortController: AbortController;
  protected fetchSetup: IPlayerConfig['fetchSetup'];

  constructor(props: Pick<IPlayerConfig, 'env' | 'fetchTimeout' | 'fetchSetup'>) {
    this.env = props.env;
    this.fetchTimeout = props.fetchTimeout;
    this.fetchSetup = props.fetchSetup || ((url, options) => ({ url, options }));
  }

  public fetchPeerConnectionConfig(playUrl: string) {
    return Promise.resolve<RTCConfiguration>({});
  }

  public abstract fetchStreamAnswer(offer: RTCSessionDescriptionInit, playUrl: string): Promise<RTCSessionDescriptionInit>;

  public abstract fetchStreamSdp(offer: RTCSessionDescriptionInit, playUrl: string): Promise<RTCSessionDescriptionInit>;

  public fetchStopStream(playUrl: string) {
    return Promise.resolve<any>(undefined);
  }

  public sdpTransform(sdp: string) {
    return sdp;
  }

  public abort(reason: string) {
    this.clearTimeout();

    if (this.abortController) {
      try {
        this.abortController.abort(reason);
        console.log('abort', reason);
        this.abortController = null;
      } catch (e) {}
    }
  }

  public clearTimeout() {
    if (this.timerId) {
      clearTimeout(this.timerId);
      this.timerId = null;
    }
  }
}
